module.exports = __webpack_public_path__ + "assets/dcc774e1f1e6df6115bfe64c2ec45544.png";